import React, { useEffect, useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const ProgressContainer = styled.div`
  height: 10px;
  border-radius: 10px;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.lightGray};
`;

const Complete = styled.div`
  width: ${({ width }) => `${width}%`};
  background: ${({ theme }) => theme.colors.primary};
  height: 100%;
  border-radius: 15px;
  transition: width 200ms ease-in-out;
`;

const Step = styled.span`
  font-size: 0.8rem;
  font-weight: bold;
`;

export default function Progress({ length, current, className }) {
  const [width, setWidth] = useState(0);

  const pctComplete = (current / length) * 100;

  useEffect(() => {
    setTimeout(() => setWidth(pctComplete), 100);
  });

  return (
    <div className={className}>
      {current > 0 && <Step>{`${current} of ${length} completed`}</Step>}
      <ProgressContainer>
        <Complete width={width} />
      </ProgressContainer>
    </div>
  );
}

Progress.defaultProps = {
  className: null,
};

Progress.propTypes = {
  length: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  className: PropTypes.string,
};
